import { read } from "Utils/Helpers/LocalStorage";
import instance from "http/Manager";

export const user_data = () => {
  return instance.get(`/users/user/${read('local')}`);
};

export const users_data = () => {
  return instance.get(`/users/clinic/${read('main-local')}`);
};

export const saveNewUser = (name, mobile, username, password) => {
    const data = {
        name, mobile, username, password,
        clinic: read('main-local'),
    }
    return instance.post(`/users`, data);
};

export const editInfo = (id, name, mobile, block) => {
    return instance.put(`/users/user-info`, { id, name, mobile, block});
};

export const editAuth = (id, username, password) => {
  return instance.put(`/users/user-auth`, { id, username, password });
};

export const editPosition = (id, position) => {
  return instance.put(`/users/user-position`, { id, position, clinic: read('main-local') });
};

export const editAccess= (id, access) => {
  return instance.put(`/users/user-access`, { id, access });
};

export const deleteUser = (id, force) => {
  return instance.delete(`/users`, {
      params: {
          id: read('main-local'),
          uid: id,
          force
      }
  });
};